import React from "react";
import "./WhatsAppButton.css"

const WhatsAppButton = () => {
  const phoneNumber = "919057255829";
  const message = encodeURIComponent(
    "Hello Dhanni Boutique ✨ I want to place an order."
  );

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M20.52 3.48A11.93 11.93 0 0012.01 0C5.38 0 .02 5.36 0 11.99a11.9 11.9 0 001.63 6.01L0 24l6.18-1.62a11.95 11.95 0 005.83 1.48h.01c6.63 0 11.99-5.36 11.99-11.99 0-3.2-1.25-6.2-3.49-8.39zm-8.51 18.36h-.01a9.9 9.9 0 01-5.05-1.39l-.36-.21-3.67.96.98-3.58-.23-.37a9.92 9.92 0 01-1.52-5.26c.01-5.48 4.48-9.95 9.97-9.95a9.9 9.9 0 016.99 2.9 9.9 9.9 0 012.9 7c0 5.49-4.47 9.95-9.99 9.95zm5.45-7.43c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.47-1.74-1.64-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.2-.24-.58-.48-.5-.66-.51h-.56c-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.52s1.08 2.93 1.23 3.13c.15.2 2.12 3.23 5.13 4.53.72.31 1.28.5 1.71.64.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.08-.12-.27-.2-.57-.35z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
